export const CURRENT_USER_TOKEN = "@me";
